import { configureStore } from "@reduxjs/toolkit";
import productReducer from './features/productSlice'
import pageReducer from './features/pageSlice'
const store = configureStore({
    reducer:{
        products:productReducer,
        page:pageReducer,
    }
})

export default store